import { offerSelector } from './offer';
import { IState } from '../../../store';

export const selectOfferRealtyUserId = (state: IState): number | null => {
  const offer = offerSelector(state);

  return offer.userId;
};
